<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconPro.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>新氧记录列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageInput">
        <el-input placeholder="请输入关键字" v-model="filters.keyword">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="query">确定</el-button>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <div class="checkButton">
          <el-form-item label="创建时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="addData">导出数据</div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="projectNo" label="ID" width="100" align="center"></el-table-column>
        <el-table-column prop="projectName" label="卡号" width="100"></el-table-column>
        <el-table-column prop="instrumentNames" label="预约码"></el-table-column>
        <el-table-column prop="docotrNames" label="订单编号"></el-table-column>
        <el-table-column prop="createTime" label="订单总金额"></el-table-column>
        <el-table-column prop="userName" label="实付预约金"></el-table-column>
        <el-table-column prop="userName" label="剩余应付(尾款)"></el-table-column>
        <el-table-column prop="userName" label="本单实付金额"></el-table-column>
        <el-table-column prop="userName" label="创建时间"></el-table-column>
        <el-table-column prop="userName" label="创建人"></el-table-column>
        <el-table-column align="center" label="操作" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">详情
            </el-button>
            <el-button size="mini" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <el-form :inline="true" :model="formData">
        <el-form-item label="项目名称">
          <el-input v-model="formData.projectName">
          </el-input>
        </el-form-item>
        <el-form-item label="可用仪器">
          <el-select v-model="formData.instrumentNames" @focus="instrumentFocus" :remote-method="remoteMethod" @change="instrumentChange" filterable remote clearable placeholder="请输入搜索可用仪器(多选)" multiple>
            <el-option v-for="item in instrumentOptions" :key="item.instrumentId" :label="item.instrumentName" :value="item.instrumentId">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="部位">
                    <el-select v-model="formData.positionId" @focus="positionFocus"
                        :remote-method="positionRemoteMethod" filterable remote clearable placeholder="请输入搜索部位"
                        @change="positionChange">
                        <el-option v-for="(item,index) in positionOptions" :key="index" :label="item.positionName"
                            :value="item.positionId">
                        </el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item label="操作人">
          <el-select v-model="formData.docotrNames" @focus="docotrFocus" :remote-method="docotrRemoteMethod" filterable remote clearable placeholder="请输入搜索部位(多选)" multiple @change="docotrChange">
            <el-option v-for="item in doctorOptions" :key="item.id" :label="item.doctorName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      formData: {
        positionName: "",
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      projectId: '',
      doctorOptions: [],
      instrumentOptions: [],
      positionOptions: [],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增项目
    add() {
      this.dialogFormVisible = true
      // 新增置空
      this.formData = {}
      this.projectId = ''
    },
    // 删除项目
    del() {
      var data = this.multipleSelection
      var id = []
      data.map(function (item, index) {
        id.push(item.projectNo)
      })
      this.$confirm('确定要删除选中的数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/project/deleteProject", {
            ids: id.toString()
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query()
            } else {
              _g.toast("error", "删除失败")
              this.query()
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    closs() {
      this.dialogFormVisible = false
    },
    instrumentChange(val) {
      console.log(val)
      this.formData.projectInstrument = val
      // console.log(this.formData.projectInstrument)
    },
    docotrChange(val) {
      this.formData.projectDoctor = val
      // console.log(this.formData.projectDoctor)
    },
    // positionChange(val) {
    //     this.formData.positionId = val
    //     console.log(val)
    //     console.log(this.formData.positionId)
    // },
    // 确定新增
    doAddgoods() {
      console.log(this.formData)
      if (this.formData.projectName == '' || !this.formData.projectName) {
        _g.toast("warning", "请填写项目名称")
        return;
      }
      if (this.formData.instrumentNames == '' || !this.formData.instrumentNames) {
        _g.toast("warning", "请填写仪器名称")
        return;
      }
      // if (this.formData.positionId == '' || !this.formData.positionId) {
      //     _g.toast("warning", "请填写部位名称")
      //     return;
      // }
      if (this.formData.docotrNames == '' || !this.formData.docotrNames) {
        _g.toast("warning", "请填写操作人名称")
        return;
      }
      let empId = Lockr.get("empId")
      if (!this.projectId) {
        // 新增项目接口
        let data = {
          projectName: this.formData.projectName,
          // positionId: this.formData.positionId,
          docotrNames: '',
          instrumentNames: '',
          userId: empId,
          projectDoctor: [{
            doctorId: ""
          }],
          projectInstrument: [{
            instrumentId: ""
          }]

        }
        var list = []
        for (let obj of this.formData.projectInstrument) {
          let resObj = {};
          resObj['instrumentId'] = obj;
          list.push(resObj)
          console.log(resObj)
        }
        data.projectInstrument = list
        console.log(this.formData.projectInstrument)

        var listData = []
        for (let obj of this.formData.projectDoctor) {
          let resObj1 = {};
          resObj1['doctorId'] = obj;
          listData.push(resObj1)
          console.log(resObj1)
        }
        data.projectDoctor = listData
        console.log(this.formData.projectDoctor)
      } else {
        // 修改项目接口
        let data = {
          id: this.projectId,
          projectName: this.formData.projectName,
          // positionId: this.formData.positionId,
          docotrNames: this.formData.docotrNames.toString(),
          userId: empId,
          instrumentNames: this.formData.instrumentNames.toString(),
          // projectDoctor: [{
          //     doctorId: ""
          // }],
          // projectInstrument: [{
          //     instrumentId: ""
          // }]
        }
        var list = []
        if (this.formData.projectInstrument) {
          for (let obj of this.formData.projectInstrument) {
            let resObj = {};
            resObj['instrumentId'] = obj;
            list.push(resObj)
          }
          data.projectInstrument = list
        }
        if (this.formData.projectDoctor) {
          var listData = []
          for (let obj of this.formData.projectDoctor) {
            let resObj1 = {};
            resObj1['doctorId'] = obj;
            listData.push(resObj1)
          }
          data.projectDoctor = listData
        }
      }

    },
    handleEdit(index, row) {
      this.dialogFormVisible = true
      this.formData = JSON.parse(JSON.stringify(row))
      this.projectId = row.projectNo
      this.formData.projectInstrument = row.instrumentIds.split(',')
      this.formData.projectDoctor = row.docotrIds.split(',')
      let turnNum = function (nums) {
        return nums.map(Number);
      }
      let turnUserDate = turnNum(row.docotrIds.split(','))
      this.formData.instrumentNames = row.instrumentIds.split(',')
      this.formData.docotrNames = turnUserDate
      this.instrumentFocus()
      this.docotrFocus()
      this.positionRemoteMethod()
      this.formData.positionName = row.positionName
      console.log(this.formData)
    },
    // 查询数据列表
    query() {
      // console.log(this.filters.startTime)
      var querys = {
        projectNo: this.filters.projectNo,
        projectName: this.filters.projectName,
        instrumentName: this.filters.instrumentName,
        createName: this.filters.createName,
        startTime: '',
        endTime: '',
        page: this.filters.pagination.page,
        size: this.filters.pagination.limit,
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.requestQuiet('/project/findProjectList', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },
    // 搜索查询全部可用仪器
    remoteMethod(val) {
      let querys = {
        instrumentName: val
      }
      api.request('/instrument/findByInstruments', querys, (res) => {
        // console.log(res)
        this.instrumentOptions = res.data
      }, (err) => { })
    },
    instrumentFocus() {
      let querys = {
        instrumentName: ''
      }
      api.request('/instrument/findByInstruments', querys, (res) => {
        // console.log(res)
        this.instrumentOptions = res.data
      }, (err) => { })
    },
    // 搜索查询全部部位
    positionRemoteMethod(val) {
      let data = {
        positionName: val
      }
      api.request('/position/findPositions', data, (res) => {
        console.log(res)
        this.positionOptions = res.data
      }, (err) => { })
    },
    positionFocus() {
      let data = {
        positionName: ''
      }
      api.request('/position/findPositions', data, (res) => {
        // console.log(res)
        this.positionOptions = res.data
      }, (err) => { })
    },
    // 搜索查询全部操作人
    docotrRemoteMethod(val) {
      let data = {
        doctorName: val
      }
      api.request('/doctor/findDoctors', data, (res) => {
        // console.log(res)
        this.doctorOptions = res.data
      }, (err) => { })
    },
    docotrFocus() {
      let data = {
        doctorName: ''
      }
      api.request('/doctor/findDoctors', data, (res) => {
        // console.log(res)
        this.doctorOptions = res.data
      }, (err) => { })
    }

  },
  mounted() {
    /*this.init();*/
    this.query()
  },
  watch: {
    '$route'(to, from) {
      this.query()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.sp1 {
  display: block;
}

.p1 {
  display: inline-block;
  color: #6e6e6e;
  font-size: 20px;
}

.p2 {
  display: inline-block;
  font-size: 20px;
  color: #000000;
  padding-left: 20px;
}

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialogItem >>> .el-input__inner {
  width: 411px;
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}
</style>